var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Link, Route } from 'react-router-dom';
import { Button, Dimmer, Form, Loader, Message } from "semantic-ui-react";
import { AppPaths } from "../../AppConfig";
import proteinLogo from "../../images/logo_Protein.png";
import { CatalogMode } from "../../RequestHelpers";
import CornerLogoContainer from "../CornerLogoContainer";
import { buildEditFormStateHandlerForComponent } from "../FormState";
import { LiquidVolume } from "../rna-cish/RnaCatalog";
import { CART_PRICE_PATH } from "../rna-fish/EditKitForm";
import { LoadWrapper } from "../rna-fish/LoadWrapper";
import { addToCartHandlerBuilder } from "../rna-fish/NewRnaFishKitPage";
import { defaultIhc2FormState, EditKitForm, serializeIhc2Kit } from "./EditKitForm";
import { Ihc2CatalogLoader } from "./Ihc2Catalog";
var NewIhc2KitPage = /** @class */ (function (_super) {
    __extends(NewIhc2KitPage, _super);
    function NewIhc2KitPage(props) {
        return _super.call(this, props) || this;
    }
    NewIhc2KitPage.prototype.render = function () {
        var _this = this;
        var renderFn = function (catalog) { return React.createElement(React.Fragment, null,
            React.createElement(NewKitContent, { catalog: catalog, legacy: _this.props.legacy, adminUser: _this.props.adminUser, legacyUser: _this.props.legacyUser })); };
        return React.createElement(React.Fragment, null,
            React.createElement(LoadWrapper, { loader: new Ihc2CatalogLoader(CatalogMode.Consumer), render: renderFn }));
    };
    return NewIhc2KitPage;
}(React.PureComponent));
export default NewIhc2KitPage;
var NewKitContent = /** @class */ (function (_super) {
    __extends(NewKitContent, _super);
    function NewKitContent(props) {
        var _this = _super.call(this, props) || this;
        _this.onAddToCart = addToCartHandlerBuilder(function (callback) {
            _this.setState({
                loading: true,
                addToCartButtonPressed: true
            }, callback);
        }, function () { return JSON.stringify(serializeIhc2Kit(_this.state.formState)); }, function (history) {
            _this.setFormState(function () { return ({
                errors: [],
            }); }, function () {
                _this.setState({
                    loading: false,
                }, function () {
                    history.push('/cart');
                });
            });
        }, function (errors) {
            _this.setFormState(function () { return ({
                errors: errors.errors,
            }); }, function () {
                _this.setState({
                    loading: false,
                });
            });
        });
        _this.setFormState = buildEditFormStateHandlerForComponent('formState', _this);
        _this.addToCartButton = function (props) {
            var onClick = function () {
                // tslint tells me that inline lambdas in props are slow, so we do it here...?
                _this.onAddToCart(props.history);
            };
            return React.createElement(Button, { icon: 'cart plus', label: 'Add to cart', labelPosition: 'left', onClick: onClick, positive: true });
        };
        _this.state = {
            loading: false,
            formState: defaultIhc2FormState(props.catalog, _this.props.legacy),
            addToCartButtonPressed: false
        };
        return _this;
    }
    NewKitContent.prototype.render = function () {
        return React.createElement(CornerLogoContainer, { img: proteinLogo, alt: 'Protein logo' },
            React.createElement("div", { id: "non-header-portion" },
                React.createElement("h1", { className: 'branded' }, this.props.legacy ? "HCR™ IF Kit" : "HCR™ Gold IF Kit"),
                React.createElement("h2", { className: 'branded' }, "Multiplex, quantitative, high-resolution protein imaging"),
                React.createElement("span", { style: { float: 'right', marginTop: '2rem' } }, this.props.legacy ?
                    React.createElement("a", { href: "https://www.molecularinstruments.com/hcr-v3-protocols" }, "HCR\u2122 (v3.0) Protocols") :
                    React.createElement("a", { href: "https://www.molecularinstruments.com/hcr-gold-protocols" }, "HCR\u2122 Gold User Guides")),
                React.createElement("p", { className: 'branded', style: { width: '50%' } },
                    "Order one ",
                    this.props.legacy ? "HCR™ IF Kit" : "HCR™ Gold IF Kit",
                    " per target protein. Use your own 1\u00BA antibody of choice without modification."),
                React.createElement("br", null),
                !this.props.legacy && (this.props.legacyUser || this.props.adminUser) &&
                    React.createElement(Message, { color: "yellow", className: 'legacy-notification' },
                        React.createElement("h2", { className: 'branded' }, "HCR\u2122 Gold Just Launched in 2025!"),
                        "Please note that HCR\u2122 Gold IF kits are not compatible with our previous-generation product line, HCR\u2122 IF, for which kits are available ",
                        React.createElement("a", { href: AppPaths.LOCAL_NEW_LEGACY_KIT_IHC2 }, "here"),
                        ". Learn more at our ",
                        React.createElement("a", { target: "_blank", href: "https://molecularinstruments.com/faq#gold-vs-v3-faq" }, "HCR\u2122 Gold vs HCR\u2122 (v3.0) FAQ"),
                        ". ",
                        React.createElement("br", null),
                        " ",
                        React.createElement("span", { style: { float: "right", marginRight: "4rem" } }, "\u2014 The MI Team"),
                        " ",
                        React.createElement("br", null)),
                this.props.legacy &&
                    React.createElement(Message, { color: "yellow", className: 'legacy-notification' },
                        React.createElement("h2", { className: 'branded' }, "HCR\u2122 Gold Just Launched in 2025!"),
                        "Please note that HCR\u2122 IF kits are not compatible with our latest-generation product line, HCR\u2122 Gold IF, for which kits are available ",
                        React.createElement("a", { href: AppPaths.LOCAL_NEW_KIT_IHC2 }, "here"),
                        ". Learn more at our ",
                        React.createElement("a", { target: "_blank", href: "https://molecularinstruments.com/faq#gold-vs-v3-faq" }, "HCR\u2122 Gold vs HCR\u2122 (v3.0) FAQ"),
                        ". ",
                        React.createElement("br", null),
                        " ",
                        React.createElement("span", { style: { float: "right", marginRight: "4rem" } }, "\u2014 The MI Team"),
                        " ",
                        React.createElement("br", null)),
                React.createElement(Dimmer.Dimmable, { as: Form, error: this.state.formState.errors.length > 0 },
                    React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                        React.createElement(Loader, null)),
                    React.createElement(EditKitForm, { kitPriceUrlPath: CART_PRICE_PATH, catalog: this.props.catalog, formState: this.state.formState, loadPriceOnMount: false, setFormState: this.setFormState, legacy: this.props.legacy, showErrors: this.state.addToCartButtonPressed }),
                    React.createElement("div", null,
                        this.props.legacy ? React.createElement("div", { style: { float: 'left', width: '50%' } },
                            "Combine with ",
                            React.createElement(Link, { to: AppPaths.LOCAL_NEW_LEGACY_KIT_RNA_FISH }, "HCR\u2122 RNA-FISH (v3.0) kits"),
                            " for simultaneous multiplex, quantitative, high-resolution RNA and protein imaging.") : React.createElement("div", { style: { float: 'left', width: '50%' } },
                            "Combine with ",
                            React.createElement(Link, { to: AppPaths.LOCAL_NEW_KIT_RNA_FISH }, "HCR\u2122 Gold RNA-FISH kits"),
                            " for simultaneous multiplex, quantitative, high-resolution RNA and protein imaging."),
                        React.createElement("div", { style: { float: 'right' } },
                            React.createElement("div", { style: { 'textAlign': 'right' } },
                                React.createElement(Route, { render: this.addToCartButton }))),
                        React.createElement("div", { style: { clear: 'both' } })))));
    };
    return NewKitContent;
}(React.PureComponent));
export var defaultProbeState = function (catalog) { return ({
    scale: catalog.defaultScale
}); };
export var defaultBuffersState = function (catalog, legacy) { return ({
    sampleType: catalog.buffer.defaultSampleType,
    antibody: catalog.buffer.antibody.defaultVolumeMl,
    amplification: catalog.buffer.amplification.defaultVolumeMl,
    goldAmpWash: !legacy ? catalog.buffer.goldAmpWash.defaultVolumeMl : new LiquidVolume(0)
}); };
//# sourceMappingURL=NewIhc2KitPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/ihc2/NewIhc2KitPage.js
// module id = 289
// module chunks = 0